import React, { Component } from 'react';
import LazyLoad from 'react-lazyload';
import { truncate } from 'lodash';
import MarkdownRenderer from 'react-markdown-renderer';
import { Col } from 'react-flexbox-grid';
import { Heading, Link, Image, Paragraph, IconSVG } from 'components';
import {
  getArticleSlug,
  estimateReadTime,
  getCloudinaryUrl,
} from 'config/helpers';
import './SinglePostTileBig.scss';

class SinglePostTileBig extends Component {
  handleCategoryClick = (event, category) => {
    event.stopPropagation();
    event.preventDefault();

    this.props.toggleFilter(category);
  };

  render() {
    const { post, contributors, theme } = this.props;
    const { frontmatter } = post.node;
    const { title, cover, settings, contributor, lead, content } = frontmatter;

    const contributorData = contributors.filter(
      edge => edge.node.frontmatter.title === contributor,
    );

    const articlePureContent = content
      .reduce((a, b) => a.body || a + b.body, '')
      .replace(/[^a-zA-Z ]/g, ' ');

    const readTime = estimateReadTime(articlePureContent);

    return (
      <Col md={12} lg={8}>
        <Link to={getArticleSlug(post)}>
          <div
            className={`single-post-tile-big ${theme &&
              `single-post-tile-big--${theme}`}`}
          >
            <div className={'single-post-tile-big__top'}>
              <LazyLoad once offset={200} height={'100%'}>
                <Image
                  src={getCloudinaryUrl(cover, 'f_auto,q_auto,h_500')}
                  alt={title}
                  placeholder
                />
              </LazyLoad>
            </div>
            <div className={'single-post-tile-big__bottom'}>
              <div>
                <button
                  onClick={e => this.handleCategoryClick(e, settings.category)}
                >
                  <Paragraph
                    size={'small'}
                    color={theme === 'black' ? 'black' : 'pigeon-post'}
                    additionalClass={
                      'single-post-tile-big__category text--bold pointer'
                    }
                  >
                    {settings.category}
                  </Paragraph>
                </button>
                <Paragraph
                  size={'small'}
                  additionalClass={'single-post-tile__time'}
                >
                  {readTime} min read
                </Paragraph>
                <IconSVG name={'time'} color={'black'} />
                <Heading type={3} size={'medium'}>
                  {title}
                </Heading>
                <Paragraph
                  color={'black'}
                  additionalClass={'text--light'}
                  nested
                >
                  <MarkdownRenderer
                    markdown={truncate(lead, { length: 200 })}
                  />
                </Paragraph>
              </div>
              {contributorData.length > 0 && (
                <div className={'single-post-tile-big__contributor'}>
                  <Image
                    src={getCloudinaryUrl(
                      contributorData[0].node.frontmatter.photo,
                      'f_auto,q_auto,w_100',
                    )}
                    alt={`${contributorData[0].node.frontmatter.title} avatar`}
                    placeholder
                  />
                  <Paragraph size={'small'}>
                    {contributorData[0].node.frontmatter.title}
                    <br />
                    <span className={'text--light'}>
                      {contributorData[0].node.frontmatter.job}
                    </span>
                  </Paragraph>
                </div>
              )}
            </div>
          </div>
        </Link>
      </Col>
    );
  }
}

SinglePostTileBig.defaultProps = {
  theme: 'white',
};

export default SinglePostTileBig;
